import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";
import {TasksService} from "../../services/tasks-service.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {TaskModel} from "../../models/task.model";
import {TaskStatusType} from "../../types/taskStatus.type";
import {isMandatoryFlagKey} from "../../../orders/utils/identifications.util";

export class taskInfoCtrl implements IController {

  task: TaskModel;
  taskMetaData: any;
  disableEditServiceTime: boolean | undefined;
  onEditIdentification: Function;
  onEditExtraInfo: Function;
  onEditTaskServiceTime: Function;
  onEditTaskDetailedServiceTime: Function;

  private configZoneId: string;
  private dynamicColumnsTaskMap: any;
  private hasPods: boolean;
  public locationTypes: typeof LocationType = LocationType;
  public taskStatusTypes: typeof TaskStatusType = TaskStatusType;
  public isTaskValidationsDone: boolean = false;
  public isTaskValidationsPartiallyDone: boolean = false;
  public enableAgentVehicleBinding: boolean;

  /* @ngInject */
  constructor(private splitService: SplitService, private tasksService: TasksService) {
    this.enableAgentVehicleBinding = this.splitService.getEnableAgentVehicleBinding();
  }

  $onInit() {
    this.configZoneId = this.splitService.getTimeZone();
    if (_.get(this.task.serviceInfo, 'metaData')) {
      this.dynamicColumnsTaskMap = _.mapKeys(this.task.serviceInfo.metaData, (value, key) => {
        return value.key;
      });
    }


    // `identifications` carries backend-shaped data that mixes POD keys
    // (`signature`) with mandatory flags (`isSignatureFillRequired`). Only
    // POD keys count as actual PODs.
    this.hasPods = _.some(this.task.taskSpec.identifications, (isPodEnabled, key) => {
      return !isMandatoryFlagKey(key) && !!isPodEnabled;
    });

    this._setValidationsStatus();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.task && !changes.task.isFirstChange()) {
      this._setValidationsStatus();
    }
  }


  private _setValidationsStatus() {
    this.isTaskValidationsDone = this.task.taskValidationList?.every(v => v.isDone);
    this.isTaskValidationsPartiallyDone = !this.isTaskValidationsDone && this.task.taskValidationList?.some(v => v.isDone);
  }


}

angular
  .module('bringoz.admin.tasks')
  .component('taskInfo', {
    bindings: {
      task: '<',
      taskMetaData: '<?',
      disableEditServiceTime: '<?',
      onEditIdentification: '&',
      onEditExtraInfo: '&',
      onEditTaskServiceTime: '&',
      onEditLocation: '&',
      onEditTaskDetailedServiceTime: '&'
    },
    template: require('./task-info.html').default,
    controller: taskInfoCtrl

  });
